module.exports = __webpack_public_path__ + "static/media/2.361d3568.png";